import store from "../store";
import Constants from "../config/constants";
import { serviceGetStaffList, serviceCreateStaff } from "../services/AdminUser.service";
import EventEmitter from "../libs/Events.utils";

export const FETCH_INIT = "FETCH_INIT_ADMIN_USER";
export const FETCHED = "FETCHED_ADMIN_USER";
export const FETCHED_FAIL = "FETCHED_FAIL_ADMIN_USER";
export const FETCHED_FILTER = "FETCHED_FILTER_ADMIN_USER";
export const NEXT_PREQUESTS = "NEXT_PREQUESTS";
export const PREV_PREQUESTS = "PREV_PREQUESTS";
export const FETCH_NEXT = "FETCH_NEXT_ADMIN_USER";
export const FILTER = "FILTER_ADMIN_USER";
export const RESET_FILTER = "RESET_FILTER_ADMIN_USER";
export const SET_SORTING = "SET_SORTING_ADMIN_USER";
export const SET_FILTER = "SET_FILTER_ADMIN_USER";
export const SET_PAGE = "SET_PAGE_ADMIN_USER";
export const CHANGE_PAGE = "CHANGE_PAGE_ADMIN_USER";
export const CHANGE_STATUS = "CHANGE_STATE_ADMIN_USER";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_ADMIN_USER";
export const CREATE_DATA = "CREATE_ADMIN_USER";
export const UPDATE_DATA = "UPDATE_ADMIN_USER";
export const DELETE_ITEM = "DELETE_ADMIN_USER";
export const PERMISSION = "PERMISSION";

export function actionFetchAdminUser(index = 1, sorting = {}, filter = {}) {
  const request = serviceGetStaffList({
    pageId: (index || 1) - 1,
    ...filter,
    type: "ADMIN",
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        const list = Array.isArray(data?.response_obj) ? data.response_obj : (Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []));
        dispatch({ type: FETCHED, payload: { data: list, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionCreateContact(data) {
    const request = serviceCreateStaff(data);
    return (dispatch) => {
        request.then((data) => {
            if (!data.error) {
                EventEmitter.dispatch(EventEmitter.THROW_ERROR, {error: 'Saved', type: 'success'});
                dispatch({type: CREATE_DATA, payload: data.data});
            }
        });
    };
}

export function actionChangePageAdminUser(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function nextPRequestsClick() {
  return {
    type: NEXT_PREQUESTS,
    payload: null,
  };
}

export function actionFilterAdminUser(value) {
  const request = null;
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null });
    });
  };
}

export function actionChangeStatusAdminUser(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterAdminUser() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageAdminUser(page) {
  const stateData = store.getState().admin_user;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchAdminUser(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
